import React, { useEffect, useState } from 'react'
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
import { hasPemissions } from '../../commons/utils';
import { Button, Divider } from '@mui/material';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { mtDividerUpTable } from '../../commons';
import { CreateDialogExpressCheckin } from '../../components/modals/checkingExpress/CreateDialogExpressCheckin';
import { RegistrosExpresCheckingTable } from '../../components/tables';



export const RegistrosExpressCheckin = () => {



  return (
    <div>


        <BreadCrumbsAndTitle
                    title="Listado Registros Express Checkin" 
                    mainModule="hotel" 
                    parent="Listado Registros Express Checkin"
                    action="" />

        
        <Divider sx={{ marginBottom: 7, border: 'none' }}/>
        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.registrosexpressChecking} />

        <RegistrosExpresCheckingTable/>

    </div>
  )
}

// expressCheckin